export const TUTORIAL_VIDEO_URL = 'https://redvike-chefs.s3.us-east-1.amazonaws.com/Surveys.mp4'
